import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  InsCommentDetail,
  InsCommentDetailVariables
} from "./types/InsCommentDetail";
import {
  InsCommentList,
  InsCommentListVariables
} from "./types/InsCommentList";
export const insCommentListFragment = gql`
  fragment InsCommentListFragment on InstagramComment {
    id
    userName
    text
    isVisible
    created
    parentType
    source
  }
`;
export const insCommentDetailsFragment = gql`
  ${insCommentListFragment}
  fragment InsCommentDetailsFragment on InstagramComment {
    ...InsCommentListFragment
    parentMedia {
      id
      shortcode
      titokDesc
      username
      image
      mimeType
    }
    parentComment {
      id
      userName
      text
    }
    comments {
      id
      created
      userName
      text
    }
  }
`;

const insCommentList = gql`
  ${insCommentListFragment}
  ${pageInfoFragment}
  query InsCommentList(
    $filter: InstagramCommentFilterInput
    $sort: InstagramCommentSortingInput
    $before: String
    $after: String
    $first: Int
    $last: Int
  ) {
    comments(
      filter: $filter
      sortBy: $sort
      before: $before
      after: $after
      first: $first
      last: $last
    ) {
      totalCount
      edges {
        node {
          ...InsCommentListFragment
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export const useInsCommentList = makeQuery<
  InsCommentList,
  InsCommentListVariables
>(insCommentList);

const insCommentDetail = gql`
  ${insCommentDetailsFragment}
  query InsCommentDetail($id: ID!) {
    commentById(id: $id) {
      ...InsCommentDetailsFragment
    }
  }
`;

export const useInsCommentDetailsQuery = makeQuery<
  InsCommentDetail,
  InsCommentDetailVariables
>(insCommentDetail);
